import request from './request';

// 获取源码列表
export function getSourceCodeList(params) {
    return request('/source/code', {
        method: 'GET',
        params
    });
}
// 获取分类列表
export function getSourceCodeCategory(params) {
    return request('/source/code/category/list', {
        method: 'GET',
        params
    });
}
// 获取首页热门推荐-源码列表
export function getSourceCodeHot(params) {
    return request('/source/code/hot/list', {
        method: 'GET',
        params
    });
}

// 获取已购买源码
export function getSourceCodePayed(params) {
    return request('/source/code/payed', {
        method: 'GET',
        params
    });
}

// 获取源码详情
export function getSourceCodeDetail(params) {
    return request(`/source/code/${params.id}`, {
        method: 'GET',
        // params
    });
}

// 收藏源码
export function collectSourceCode(params) {
    return request('/source/code/collection/add', {
        method: 'GET',
        params
    });
}

// 取消收藏源码
export function cancelCollectSourceCode(params) {
    return request('/source/code/collection/cancel', {
        method: 'GET',
        params
    });
}

// 我的收藏源码
export function getMyCollectSourceCode(params) {
    return request('/source/code/collection', {
        method: 'GET',
        params
    });
}

// 下载源码
export function downloadSourceCode(id) {
    return request(`/source/code/download?materialId=${id}`, {
        method: 'POST'
    });
}


export function getAllSourceCodeAuthor() {
    return request(`/source/code/designer/list`, {
        method: 'GET',
    });
}

export function getSourceCodeByAuthor(params) {
    return request(`/source/code/designer`, {
        method: 'GET',
        params
    });
}
